<div
  class="d-flex flex-column justify-content-center align-items-center login-container home"
>
  <p-card header="Welcome to" styleClass="card-login">
    <!-- <ng-template pTemplate="header">
      <div class="pt-3 px-4 d-flex justify-content-start">
        <a
          style="
            color: var(--theme-primary-color);
            font-weight: bold;
            text-decoration: none;
            font-size: 15px;
          "
          [href]="linkForUserManual"
          target="_blank"
        >
          User Manual
        </a>
      </div>
    </ng-template> -->
    <div class="d-flex justify-content-end align-items-center">
      <div class="mt-2">
        <img
          src="assets/images/logo/logo-text.svg"
          height="50"
          class="d-inline-block align-top"
          alt=""
          loading="lazy"
        />
      </div>
      <!-- <div class="f-43 fw-bold">Bestione</div> -->
    </div>
    <div
      class="d-flex justify-content-end align-items-center"
      style="margin-top: -7rem; margin-right: -120px; margin-left: -48px"
    >
      <div>
        <img
          src="assets/images/logo/expdoc-logo-new.png"
          width="600"
          class="d-inline-block align-top"
          alt=""
          loading="lazy"
        />
      </div>
      <!-- <span class="f-43 fw-bold" style="margin-left: 10rem">EXP DOC</span> -->
    </div>
    <div
      class="w-100 d-flex flex-wrap gap-4 justify-content-center"
      style="margin-top: -5rem;padding-right: 10px;"
    >
      <!-- label="Sign in AD {{ environmentText }}" -->
      <p-button
        label="Login-SCGC"
        styleClass="p-button-rounded p-button-outlined p-button-size"
        (click)="signInMSAL()"
      ></p-button>
      <!-- label="Sign in B2C {{ environmentText }}" -->
      <p-button
        label="Login-Customer"
        styleClass="p-button-rounded p-button-size"
        (click)="signInMSALB2C()"
      ></p-button>
      <!-- <p-button
        label="Forgot password"
        styleClass="p-button-rounded p-button-secondary"
        (click)="resetPasswordMSAL()"
      ></p-button> -->
    </div>
    <div
      *ngIf="haveMaintenance"
      class="d-flex justify-content-center align-items-center mt-4"
    >
      <div class="flex-auto mt-px border-t"></div>
      <div class="mx-2 text-red-600">
        <span *ngIf="underMaintenance">
          There is ongoing server maintenance. Some Skyflow modules might not be
          able to use.
        </span>
        <span *ngIf="!underMaintenance">There will be server maintenance.</span>
        <a
          class="underline"
          style="cursor: pointer"
          (click)="showMaintenanceSchedule()"
        >
          [View Schedule and Detail]
        </a>
      </div>
      <div class="flex-auto mt-px border-t"></div>
    </div>
    <div
      class="mt-3 d-flex justify-content-end"
      style="padding-right: 10px;"
    >
    <a
    style="
          color: var(--theme-primary-color);
        "
      [href]="linkCreateAccount"
      >
       Create Account
      </a>
      <a
      class="underline"
      style="
          color: var(--theme-primary-color);
          margin-left: 1rem;
          cursor: pointer;
        "
      (click)="resetPasswordMSAL()"
      >
       Forgot password
      </a>
    </div>
    <div class="mt-3 d-flex justify-content-end"
    style="padding-right: 10px;">
      
      <!-- <a
        style="
          color: var(--theme-info-color);
          font-weight: bold;
          text-decoration: none;
          font-size: 15px;
        "
        [href]="linkForHelp"
        target="_blank"
      >
        Help
      </a> -->
      <a
        style="
          font-weight: bold;
          text-decoration: none;
          font-size: 15px;
          display: inline-block;
          align-self: flex-end;
        "
      >
        User Manual
      </a>
      <a
        style="
          color: var(--theme-primary-color);
          font-weight: bold;
          text-decoration: none;
          font-size: 17px;
          margin-left: 1rem;
        "
        [href]="linkForUserManualPDF"
        target="_blank"
      >
        <i class="fa-solid fa-file-pdf"></i>
      </a>
    </div>
  </p-card>
</div>
